import { render } from "./DateRange.vue?vue&type=template&id=2ca4fe01&scoped=true&ts=true"
import script from "./DateRange.vue?vue&type=script&lang=ts"
export * from "./DateRange.vue?vue&type=script&lang=ts"

import "./DateRange.vue?vue&type=style&index=0&id=2ca4fe01&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca4fe01"]])

export default __exports__